document.addEventListener("DOMContentLoaded", function() {
  async function addToCart(productId, title) {
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: productId })
      });
      const data = await response.json();
      if (data && data.status && data.status !== 200) {
        return false;
      }
      handleAfterAddToCart(title);
      return true;
    } catch (error) {
      return false;
    }
  }

  function handleAfterAddToCart(title) {
    const mode = window.theme && theme.settings && theme.settings.afterAddToCart;
    if (mode === "notification") {
      const tpl = document.getElementById("AddedNotification");
      if (!tpl || !tpl.content) return;
      const notification = tpl.content.firstElementChild.cloneNode(true);
      notification.dataset.productTitle = title;
      const container = document.querySelector(".pageheader--sticky") || document.body;
      container.appendChild(notification);
    } else if (mode === "drawer") {
      const drawer = document.querySelector(".js-cart-drawer");
      if (drawer && typeof drawer.open === "function") drawer.open();
    }
  }

  function startLoader(btn) {
    if (!btn) return;
    btn.classList.add("plp-atc-load-start");
    btn.style.color = "transparent";
    btn.disabled = true;
  }

  function endLoader(btn) {
    if (!btn) return;
    btn.classList.remove("plp-atc-load-start");
    btn.classList.add("plp-atc-load-end");
    setTimeout(() => {
      btn.classList.remove("plp-atc-load-end");
      btn.style.removeProperty("color");
      btn.disabled = false;
    }, 1000);
  }

  function showVariantSelectorModal(variants, title, sourceBtn, productId, sectionId) {
    const modal = document.getElementById("variant-selector-modal");
    const variantOptions = document.getElementById("variant-options");
    const addToCartButton = document.getElementById("add-to-cart-button");
    const productTitle = document.getElementById("product-title");
    const messageContainer = document.getElementById("variant-message");

    if (modal) {
      if (productId) modal.dataset.productId = String(productId);
      if (sectionId) modal.dataset.sectionId = String(sectionId);
    }

    if (!modal || !variantOptions || !addToCartButton || !productTitle) {
      endLoader(sourceBtn);
      return;
    }

    if (messageContainer) {
      messageContainer.textContent = "";
    }

    productTitle.textContent = title || "";
    variantOptions.innerHTML = "";

    variants.forEach((variant, index) => {
      const variantOption = createVariantOption(variant, index);
      variantOptions.appendChild(variantOption);
    });

    function closeModal() {
      modal.style.display = "none";
      if (modal._outsideClose) {
        window.removeEventListener("click", modal._outsideClose);
        modal._outsideClose = null;
      }
      endLoader(sourceBtn);
    }

    addToCartButton.onclick = (e) => handleAddToCartButtonClick(title, modal, e, sourceBtn);
    modal.style.display = "flex";

    const closeEl = document.querySelector(".plp-atc-close");
    if (closeEl) closeEl.onclick = closeModal;

    modal._outsideClose = function(event) {
      if (event.target === modal) closeModal();
    };
    window.addEventListener("click", modal._outsideClose);
  }

  function getVariantLabelText(variant) {
    if (typeof variant.option2 === "string" && variant.option2.trim()) {
      return variant.option2;
    }
    const parts = (variant.title || "").split("/").map(s => s.trim());
    if (parts.length > 1 && parts[1]) {
      return parts[1];
    }
    return variant.title || "Option";
  }

  function createVariantOption(variant, index) {
    const variantOption = document.createElement("div");
    const variantId = `variant-option-${index}`;
    const labelText = getVariantLabelText(variant);
    variantOption.innerHTML = `
      <label class="opt-label opt-label--btn btn relative text-center" for="${variantId}">
        <span class="js-value">${labelText}</span>
      </label>
      <input type="radio" class="opt-btn visually-hidden focus-label js-option" name="variant" id="${variantId}" value="${variant.id}" required>
    `;
    const input = variantOption.querySelector("input");
    input.addEventListener("change", function() {
      document.querySelectorAll(".opt-label").forEach(label => label.classList.remove("selected-variant"));
      variantOption.querySelector(".opt-label").classList.add("selected-variant");
      const msg = document.getElementById("variant-message");
      if (msg) msg.textContent = "";
    });
    return variantOption;
  }

  async function handleAddToCartButtonClick(title, modal, e, sourceBtn) {
    const el = e.target;
    const selectedVariant = document.querySelector('input[name="variant"]:checked');
    const messageContainer = document.getElementById("variant-message");
    const messageDiv = document.querySelector(".message");

    if (!selectedVariant) {
      if (!messageContainer) {
        if (messageDiv) {
          const m = document.createElement("div");
          m.id = "variant-message";
          m.style.color = "red";
          m.textContent = "Please select a size before adding to cart.";
          messageDiv.appendChild(m);
        }
      } else {
        messageContainer.textContent = "Please select a size before adding to cart.";
      }
      return;
    }

    if (messageContainer) {
      messageContainer.textContent = "";
    }

    el.classList.add("plp-atc-load-start");
    el.style.color = "transparent";

    const ok = await addToCart(selectedVariant.value, title);

    el.classList.remove("plp-atc-load-start");
    el.classList.add("plp-atc-load-end");
    setTimeout(() => {
      el.classList.remove("plp-atc-load-end");
      el.style.removeProperty("color");
      if (ok) {
        if (modal && modal._outsideClose) {
          window.removeEventListener("click", modal._outsideClose);
          modal._outsideClose = null;
        }
        if (modal) modal.style.display = "none";
        endLoader(sourceBtn);
      } else {
        const msg = document.getElementById("variant-message") || document.createElement("div");
        if (!msg.id) {
          msg.id = "variant-message";
          msg.style.color = "red";
          msg.textContent = "Could not add to cart. Please try again.";
          const host = document.querySelector(".message") || modal;
          if (host) host.appendChild(msg);
        } else {
          msg.style.color = "red";
          msg.textContent = "Could not add to cart. Please try again.";
        }
        endLoader(sourceBtn);
      }
    }, 1000);
  }

  document.addEventListener("click", async (e) => {
    const plpAtc = e.target.closest(".plp-atc");
    if (!plpAtc || plpAtc.classList.contains("event-attached")) return;

    plpAtc.classList.add("event-attached");
    const btn = plpAtc;
    startLoader(btn);

    const handle = plpAtc.getAttribute("data-product-handle");
    if (!handle) {
      endLoader(btn);
      setTimeout(() => plpAtc.classList.remove("event-attached"), 600);
      return;
    }

    try {
      const productData = await fetch(`/products/${handle}.json`).then(res => res.json());
      const variants = productData?.product?.variants || [];
      const title = productData?.product?.title || "";
      const productId = productData?.product?.id ? String(productData.product.id) : (plpAtc.dataset.productId || "");
      const sectionId = plpAtc.dataset.sectionId || "";

      const variantModal = document.getElementById("variant-selector-modal");
      if (variantModal) {
        if (productId) variantModal.dataset.productId = productId;
        if (sectionId) variantModal.dataset.sectionId = sectionId;
      }

      if (variants.length > 1) {
        showVariantSelectorModal(variants, title, btn, productId, sectionId);
      } else if (variants.length === 1) {
        const ok = await addToCart(variants[0].id, title);
        endLoader(btn);
      } else {
        console.error("No variants found for product:", handle);
        endLoader(btn);
      }
    } catch (error) {
      endLoader(btn);
    } finally {
      setTimeout(() => {
        plpAtc.classList.remove("event-attached");
      }, 600);
    }
  });

  document.addEventListener("click", function(e) {
    if (!e.target.classList.contains("plp-atc-modal-size-chart")) return;

    const modal = document.getElementById("variant-selector-modal");
    const pid = modal?.dataset?.productId || "";
    let sid = modal?.dataset?.sectionId || "";

    let targetEl = null;

    if (pid && sid) {
      const id = `size-chart-${pid}-${sid}`;
      targetEl = document.getElementById(id);
    }

    if (!targetEl && pid) {
      const candidates = document.querySelectorAll(`modal-dialog[id^="size-chart-${pid}-"]`);
      if (candidates.length) {
        targetEl = candidates[0];
        const prefix = `size-chart-${pid}-`;
        sid = targetEl.id.startsWith(prefix) ? targetEl.id.slice(prefix.length) : "";
        modal.dataset.sectionId = sid;
      }
    }

    if (!targetEl) {
      return;
    }

    e.target.setAttribute("data-target", targetEl.id);
    e.target.setAttribute("aria-controls", targetEl.id);
    e.target.setAttribute("aria-expanded", "true");

    targetEl.removeAttribute("aria-hidden");
    targetEl.setAttribute("open", "");
    document.body.classList.add("overflow-hidden");
  });

  document.addEventListener("click", function(e) {
    if (!e.target.classList.contains("js-close-modal")) return;

    const m = e.target.closest("modal-dialog");
    if (!m) {
      return;
    }

    m.setAttribute("aria-hidden", "true");
    m.removeAttribute("open");
    document.body.classList.remove("overflow-hidden");

    const triggerBtn = document.querySelector(`.plp-atc-modal-size-chart[aria-controls="${m.id}"]`);
    if (triggerBtn) {
      triggerBtn.setAttribute("aria-expanded", "false");
    }
  });
});


(function() {
  function vm() { return document.getElementById("variant-selector-modal"); }
  function hideVM() {
    const el = vm();
    if (!el) return;
    if (!el.dataset.prevDisplay) el.dataset.prevDisplay = getComputedStyle(el).display || "";
    el.style.display = "none";
  }
  function showVM() {
    const el = vm();
    if (!el) return;
    const prev = el.dataset.prevDisplay || "flex";
    el.style.display = prev;
    delete el.dataset.prevDisplay;
  }

  document.addEventListener("click", function(e) {
    if (e.target.closest(".plp-atc-modal-size-chart")) hideVM();
    if (e.target.closest("modal-dialog.size-chart-stacked .js-close-modal")) showVM();
    const dlg = e.target.closest("modal-dialog.size-chart-stacked");
    if (dlg && e.target === dlg) showVM();
  });

  document.addEventListener("keydown", function(e) {
    if (e.key === "Escape") {
      // Find any open modal-dialog and close it
      const openModal = document.querySelector('modal-dialog[open]');
      if (openModal) {
        openModal.setAttribute("aria-hidden", "true");
        openModal.removeAttribute("open");
        document.body.classList.remove("overflow-hidden");
        // Reset aria-expanded on trigger button if applicable
        const triggerBtn = document.querySelector(`.plp-atc-modal-size-chart[aria-controls="${openModal.id}"]`);
        if (triggerBtn) {
          triggerBtn.setAttribute("aria-expanded", "false");
        }
      }
    }
  });
})();



